import styled from 'styled-components';

export const SocialLink = styled.a`
  display: block;

  @media (${({ theme }) => theme.respondTo.tabletAndMobile}) {
    margin: 0 0.5rem;
  }

  @media (${({ theme }) => theme.respondTo.desktop}) {
    margin-bottom: 1rem;
  }
`;

export const Wrapper = styled.div`
  @media (${({ theme }) => theme.respondTo.tabletAndMobile}) {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1rem;
  }
`;
